import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { StubPageComponent } from './stub-page.component'

@NgModule({
  declarations: [StubPageComponent],
  imports: [CommonModule, RouterModule],
  exports: [StubPageComponent],
})
export class StubPageModule {}
